import { useEffect } from "react";
import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { H2, BodyText } from "src/atoms/typography";
import { SceneLayout } from "src/components/SceneLayout";
import NavigationButtons from "src/components/NavigationButtons";
import { Lottie } from "src/components/Lottie";
import { ReactComponent as ShowCodeIcon } from "src/modules/pairing/icons/qr_code.svg";
import { ReactComponent as EnterCodeIcon } from "src/modules/pairing/icons/scan.svg";
import SvgContainer from "src/components/SvgContainer";

export default function ManualPairing({ flow, mode, closeWizard, app }) {
  const { t } = useTranslation();
  const shouldClose = flow.history.reduce((acc, entry) => {
    const wasInDevicesBefore = entry === "nearby-devices";
    if (!acc) return acc;
    if (wasInDevicesBefore) acc = false;
    return acc;
  }, true);

  useEffect(() => {
    app.emitter.on("camera-dialog-dismiss", handleSettingsDismiss);
    return () => {
      app.emitter.off("camera-dialog-dismiss", handleSettingsDismiss);
    };
  }, []);

  const handleSettingsDismiss = () => {
    flow.push("enter-code");
  };

  const checkForPermissions = async () => {
    const status = await app.permissions.getMediaAccessStatus("camera");
    if (status === "not-determined") {
      const access = await app.permissions.askForMediaAccess("camera");
      if (!access) flow.push("enter-code");
      if (access) flow.push("scan-qr-code");
      return;
    }
    if (status === "granted") {
      flow.push("scan-qr-code");
      return;
    }
    app.permissions.openDialog("camera");
  };

  return (
    <>
      <NavigationButtons
        mode={mode}
        onClose={mode === "modal" && closeWizard}
        onBack={
          mode === "modal"
            ? null
            : () => (shouldClose ? closeWizard() : flow.push("nearby-devices", { direction: "previous" }))
        }
      />
      <SceneLayout
        centerProps={{ width: "320px", mt: mode === "modal" ? "0px" : "-32px" }}
        center={
          <>
            <Lottie animationName="qr-scan.json" width="220px" />
            <H2 textAlign="center" color="highEmphasis" mt="16px">
              {t("pairing.qr.display")}
            </H2>
            <BodyText textAlign="center" mt="8px" color="mediumEmphasis">
              {t("pairing.manually.text")}
            </BodyText>
          </>
        }
        bottomProps={{ mb: "24px" }}
        bottom={
          <>
            <Button
              variant="containedSecondary"
              onClick={() => flow.push("display-code")}
              position="relative"
              minWidth="208px"
            >
              <SvgContainer
                icon={ShowCodeIcon}
                position="absolute"
                left="16px"
                top="50%"
                size="24px"
                transform="translate(0%, -50%)"
              />
              {t("showCode")}
            </Button>

            <Button
              variant="containedPrimary"
              onClick={checkForPermissions}
              position="relative"
              mt="8px"
              minWidth="208px"
            >
              <SvgContainer
                icon={EnterCodeIcon}
                position="absolute"
                left="16px"
                top="50%"
                size="24px"
                transform="translate(0%, -50%)"
              />
              {t("scanCode")}
            </Button>
          </>
        }
      />
    </>
  );
}
